<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="280px" :rules="rules">
				<el-row>
					<el-col :span="24"> 
						<el-form-item label="岗位名称+d待遇(不要超过22字符)" prop="name"><el-input v-model="formParameter.name" 
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="经验（不要超过4字符）" prop="experience"><el-input v-model="formParameter.experience"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="学历经验（不要超过5字符）" prop="education"><el-input v-model="formParameter.education"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="职能类别(java，前端，高级，初级，全栈)" prop="subject">
							<el-input v-model="formParameter.subject" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="技术栈(不要超出显示边境)" prop="tech">
							<!-- <el-input v-model="formParameter.tech" autocomplete="off"></el-input> -->
							<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
								@close="handleClose(tag)">
								{{ tag }}
							</el-tag>
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
								size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
							</el-input>
							<el-button v-else class="button-new-tag" size="small" @click="showInput">+NewTag</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="招聘公司" prop="company"><el-input v-model="formParameter.company"
								autocomplete="off">
							</el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="就业地点" prop="place"><el-input v-model="formParameter.place"
								autocomplete="off">
							</el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="外链地址" prop="orgurl">
							<el-input v-model="formParameter.orgurl"
								autocomplete="off">
							</el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="24">
						<el-form-item label="职位信息" prop="detail">
							<el-input v-model="formParameter.detail" autocomplete="off">
							</el-input>
						</el-form-item>
					</el-col> -->
				</el-row>
				<!-- <el-row>
					<el-col :span="24">
						<el-form-item label="创建时间" prop="createTime"><el-input v-model="formParameter.createTime"autocomplete="off">
						</el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="更新时间" prop="updateTime"><el-input v-model="formParameter.updateTime"autocomplete="off">
						</el-input></el-form-item>
					</el-col>
				</el-row> -->
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/online/onlinejobs/onlinejobs.js';
import wangEdit from '@/components/wangEdit/wangEdit.vue';
export default {
	name: 'edit',
	components: {
		popup,
		wangEdit
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			dynamicTags: [],
			inputVisible: false,
			inputValue: '',

			rules: {
				//名称
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 22,
						trigger: 'blur'
					}
				],
				//经验
				experience: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 3,
						trigger: 'blur'
					}
				],
				//学历
				education: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 5,
						trigger: 'blur'
					}
				],
				//职能类别(java,前端，全栈)
				subject: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//技术栈（数组）
				// tech: [
				// 	{
				// 		validator: this.$validate.required,
				// 		trigger: 'blur'
				// 	},
				// 	{
				// 		validator: this.$validate.length,
				// 		max: 255,
				// 		trigger: 'blur'
				// 	}
				// ],
				//招聘公司
				company: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//就业地点

				place: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
		 
		 
			},

		};

	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);

					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			// 清空添加时标签内容
			this.inputValue = "";
			this.dynamicTags = [];
			// 清空富文本文本内容
			//this.$refs.ss.init();
			//赋值添加时标签内容
			this.formParameter.tech = this.dynamicTags;

			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					// 添加已有的内容
					//this.$refs.ss.init(this.formParameter.detail);
					this.dynamicTags = JSON.parse(this.formParameter.tech);
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		},
		handleClose(tag) {
			this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			this.formParameter.tech = this.dynamicTags;
		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},

		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.dynamicTags.push(inputValue);
				this.formParameter.tech = this.dynamicTags;
			}
			this.inputVisible = false;
			this.inputValue = '';
		}
	}

}

</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
